module.exports = __webpack_public_path__ + "img/annualBack.70aa68c0.png";